import React from 'react';
import PropTypes from 'prop-types';
import { Button, Badge, CurrencyFormat } from '@lt/components';
import cn from 'classnames';

import { useTranslation } from '@lt/localization';
import { numToWords } from 'src/utils/stringUtils';
import Nbsp from '../../../../../../components/Nbsp';

import Facilities from './ExtraRoomsFacilities';
import ExtraRoomsButton from './ExtraRoomsButton';

const ExtraRoomsItem = ({
  originalPackageId,
  currentPackageId,
  onClick,
  aboutRoomOnClick,
  baseCls,
  item,
  index,
  isMobile,
  touristsCount,
}) => {
  const {
    name_ru: name,
    area,
    price_difference: price,
    hotel_room_facility_types: facilities,
    name_en: type,
    package_id: packageId,
  } = item;

  const { t } = useTranslation();
  const isActive = currentPackageId === packageId;
  const tourists = numToWords(touristsCount);

  const title = area ? `${name} · ${area}${t('commonPages.distanceM')}` : name;
  const isOriginalRoom = originalPackageId === packageId;
  const isVip = index === 2; // last element

  const itemCls = `${baseCls}-item`;
  const listItemCls = cn(itemCls, {
    [`${itemCls}--original`]: isOriginalRoom,
    [`${itemCls}--vip`]: isVip,
  });

  return (
    <li className={listItemCls}>
      <h3 className={`${itemCls}__title`}>{title}</h3>

      <div>
        <small className={`${itemCls}__type`}>{type}</small>

        <Button
          type="button"
          functional
          className={`${itemCls}__about lt-link`}
          onClick={() => aboutRoomOnClick(packageId)}
        >
          {t('checkout.packageInfo.room.aboutButton')}
        </Button>
      </div>

      <Facilities
        isOriginalRoom={isOriginalRoom}
        items={facilities}
        baseCls={baseCls}
        isMobile={isMobile}
      />

      {!isActive && price > 0 && (
        <div className={`${itemCls}__price`}>
          <Badge primary>
            <CurrencyFormat value={price} prefix="+&nbsp;" />
          </Badge>
          <Nbsp />
          {/* TODO: исправить ключ в задаче: https://leveltravel.atlassian.net/browse/LT-30398 */}
          {t('filters.prices.title_on')} {tourists}
        </div>
      )}

      <ExtraRoomsButton
        isOriginalRoom={isOriginalRoom}
        isActive={isActive}
        isVip={isVip}
        baseCls={baseCls}
        packageId={packageId}
        onClick={onClick}
      />
    </li>
  );
};

ExtraRoomsItem.defaultProps = {
  item: null,
};

ExtraRoomsItem.propTypes = {
  item: PropTypes.arrayOf(PropTypes.shape({})), // TODO: PropTypes
  baseCls: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  aboutRoomOnClick: PropTypes.func.isRequired,
  originalPackageId: PropTypes.number.isRequired,
  currentPackageId: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
  isMobile: PropTypes.bool.isRequired,
  touristsCount: PropTypes.number.isRequired,
};

export default ExtraRoomsItem;
